/**
 * Represents a create account component.
 */
export default class CreateAccountAnchor {
  /**
   * Creates a new instance of CreateAccountAnchor.
   * @constructor
   */
  constructor() {
    this.buttonId = 'createAccountBtn';
  }

  /**
   * Binds events to the CreateAccountAnchor component.
   * @function bindEvents
   * @memberof CreateAccountAnchor
   * @instance
   */
  bindEvents() {
    const anchor = this.getAnchor();
    anchor?.addEventListener('click', ()=> document.body.dispatchEvent(new CustomEvent('createAccountAnchorClick')));
  }

  /**
   * Gets the anchor element by ID.
   * @returns {HTMLElement} The anchor element.
   */
  getAnchor() {
    return document.getElementById(this.buttonId);
  }

  /**
   * Gets the HTML for the create account anchor component.
   * @returns {string} The HTML for the create account anchor component.
   */
  getHtml() {
    return `
      <button id="${this.buttonId}" class="btn btn--white btn--48-lg" data-close data-component="sign-in" data-qa="CreateAccount"> 
        Create Account
      </button>`;
  }
}